import React from "react";
import HeaderOne from "../components/HeaderOne";
import ColorInit from "../helper/ColorInit";
import { CartProvider } from "../contexts/CartContext";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import PrivacyPolicy from "../components/PrivacyPolicy";
import ScrollToTop from "react-scroll-to-top";
const PrivacyPolicyPage = () => {
  return (
    <CartProvider>
      <ScrollToTop smooth color="#ef253c" />
      <ColorInit color={"bigmall"} />
      <HeaderOne />
      <div className="px-20">
        <PrivacyPolicy />
      </div>
      <FooterOne />
      <BottomFooter />
    </CartProvider>
  );
};
export default PrivacyPolicyPage;
